import { IPIDeliverance } from "dto/PI/IPIDeliverance";

/**
 * Dane przykładowe rejestru „Doręczenia PI" — używane jako fallback, gdy
 * endpoint integracji z Portalem Informacyjnym nie jest dostępny (dev / brak BE).
 */
export const mockPIDeliverances: IPIDeliverance[] = [
  {
    Id: "pi-0001",
    PortalDocumentId: "PI/2026/WA/000123",
    CaseSignature: "I C 1234/25",
    Court: "Sąd Okręgowy w Warszawie",
    Department: "I Wydział Cywilny",
    DocumentType: "Zarządzenie",
    Title: "Zarządzenie o wezwaniu do uzupełnienia braków formalnych",
    Judge: "SSO Jan Kowalski",
    Client: "Przedsiębiorstwo Handlowe „Wektor” sp. z o.o.",
    PublicationDate: "2026-06-01T10:15:00",
    DeliveryDate: "2026-06-15T10:15:00",
    ReadDate: "2026-06-03T08:42:00",
    Status: "Odczytane",
  },
  {
    Id: "pi-0002",
    PortalDocumentId: "PI/2026/WA/000204",
    CaseSignature: "II K 567/26",
    Court: "Sąd Rejonowy dla Warszawy-Mokotowa",
    Department: "III Wydział Karny",
    DocumentType: "Postanowienie",
    Title: "Postanowienie o dopuszczeniu dowodu z opinii biegłego",
    Judge: "SSR Anna Nowak",
    Client: "Tomasz Wiśniewski",
    PublicationDate: "2026-06-04T14:30:00",
    DeliveryDate: "2026-06-18T14:30:00",
    ReadDate: undefined,
    Status: "Opublikowane",
  },
  {
    Id: "pi-0003",
    PortalDocumentId: "PI/2026/GD/000087",
    CaseSignature: "V GC 89/26",
    Court: "Sąd Okręgowy w Gdańsku",
    Department: "IX Wydział Gospodarczy",
    DocumentType: "Wyrok",
    Title: "Wyrok wraz z uzasadnieniem",
    Judge: "SSO Piotr Zieliński",
    Client: "Stocznia Remontowa „Marina” S.A.",
    PublicationDate: "2026-05-28T09:00:00",
    DeliveryDate: "2026-06-11T09:00:00",
    ReadDate: "2026-05-29T11:20:00",
    Status: "Odczytane",
  },
  {
    Id: "pi-0004",
    PortalDocumentId: "PI/2026/KR/000310",
    CaseSignature: "I Ns 245/26",
    Court: "Sąd Rejonowy dla Krakowa-Śródmieścia",
    Department: "I Wydział Cywilny",
    DocumentType: "Zawiadomienie",
    Title: "Zawiadomienie o terminie posiedzenia",
    Judge: "SSR Katarzyna Lewandowska",
    Client: "Maria Dąbrowska",
    PublicationDate: "2026-06-08T12:45:00",
    DeliveryDate: undefined,
    ReadDate: undefined,
    Status: "Opublikowane",
  },
  {
    Id: "pi-0005",
    PortalDocumentId: "PI/2026/WA/000356",
    CaseSignature: "XXV C 998/25",
    Court: "Sąd Okręgowy w Warszawie",
    Department: "XXV Wydział Cywilny",
    DocumentType: "Postanowienie",
    Title: "Postanowienie o zabezpieczeniu roszczenia",
    Judge: "SSO Marek Wójcik",
    Client: "FinTech Solutions sp. z o.o.",
    PublicationDate: "2026-06-06T16:10:00",
    DeliveryDate: "2026-06-20T16:10:00",
    ReadDate: "2026-06-09T09:05:00",
    Status: "Odczytane",
  },
  {
    Id: "pi-0006",
    PortalDocumentId: "PI/2026/PO/000142",
    CaseSignature: "II Ca 412/26",
    Court: "Sąd Okręgowy w Poznaniu",
    Department: "II Wydział Cywilny Odwoławczy",
    DocumentType: "Uzasadnienie",
    Title: "Uzasadnienie wyroku sądu II instancji",
    Judge: "SSO Agnieszka Kaczmarek",
    Client: "Spółdzielnia Mieszkaniowa „Przyszłość”",
    PublicationDate: "2026-06-02T08:20:00",
    DeliveryDate: "2026-06-16T08:20:00",
    ReadDate: undefined,
    Status: "Doręczone",
  },
];

export default mockPIDeliverances;
